import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../static/css/tumhesaplar.css";
import Footer from '../components/Footer';
import Header from '../components/Header';

const buttons = [
    { text: "Araç Değer Kaybı Hesapla", href: "/hesaplamalar/arac-deger-kaybi-hesaplama" },
    { text: "Askerlik Borçlanması Hesapla", href: "/hesaplamalar/askerlik-borclanmasi-hesaplama" },
    { text: "Bilirkişi Asgari Tarifeleri", href: "/hesaplamalar/bilirkisi-asgari-tarifeleri" },
    { text: "Fazla Çalışma Hesapla", href: "/hesaplamalar/fazla-calisma-hesaplama" },
    { text: "Islah Harcı Hesapla", href: "/hesaplamalar/islah-harci-hesaplama" },
    { text: "İcra Masrafı Hesapla", href: "/hesaplamalar/icra-masrafi-hesaplama" },
    { text: "İhbar Tazminatı Hesapla", href: "/hesaplamalar/ihbar-tazminati-hesaplama" },
    { text: "İş Günü Hesapla", href: "/hesaplamalar/is-gunu-hesaplama" },
    { text: "Kıdem Tazminatı Hesapla", href: "/hesaplamalar/kidem-tazminati-hesaplama" },
    { text: "Mahkeme Harç ve Gider Hesaplama", href: "/hesaplamalar/mahkeme-harc-ve-gider-hesaplama" },
    { text: "Tahliye Taahhütnamesine Dayalı İcra Hesapla", href: "/hesaplamalar/tahliye-taahhutnamesine-dayali-icra-hesaplama" },
    { text: "Tapu Harcı Hesapla", href: "/hesaplamalar/tapu-harci-hesaplama" },
    { text: "Vekalet Ücreti Hesapla", href: "/hesaplamalar/vekalet-ucreti-hesaplama" },
    { text: "Yıllık İzin Süresi Hesapla", href: "/hesaplamalar/yillik-izin-suresi-hesaplama" },
];

const TumHesaplar = () => {
    return (
        <>
            <Helmet>
                <title>Tüm Hesaplamalar - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Sitemizde bulunan tüm hesaplama çeşitleri." />
            </Helmet>

            <Header />
            <section className="bg-custom-gray py-5">
                <div className="container-fluid px-2" style={{ maxWidth: '90vw' }}>
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>Tüm Hesaplamalar</li>
                    </ol>

                    <h1 className="fw-semibold">Sitemizdeki Tüm Hesaplamalar</h1>
                    <p>Mevzuat ile uyumlu, devamlı güncel, hızlı ve dinamik</p>

                    <div className="row mt-4">
                        {buttons.map((button, index) => (
                            <div className="col-md-4 mb-3" key={index}>
                                <Link
                                    to={button.href}
                                    className="px-4 custom-button text-decoration-none d-flex align-items-center"
                                >
                                    {button.text}
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default React.memo(TumHesaplar);
